<template>
  <fieldset class="tla-form-group" v-if="showComponent">
    <div class="pre-sub-consent">
      <span class="pre-sub-consent__text" v-html="initialSettings.marketingPolicyVersionText"></span>
      <label class="tla-check" for="presubMarketing-optinAll">
        <input class="tla-check__checkbox" type="checkbox" v-model="optInAll" @change="setOptIn(optInAll)" id="presubMarketing-optinAll"/>
        <div class="tla-check__indicator"></div>
      </label>
    </div>
  </fieldset>
</template>

<script lang='ts'>
import {
  Component, Vue, Prop, Watch
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import OptInData from '../../models/OptInData';

const InitialSettingsModule = namespace('initialSettingsModule');
const EnquiryModule = namespace('enquiryModule');

@Component({})
export default class PresubMarketingConsentComponent extends Vue {
  @InitialSettingsModule.Getter public initialSettings;

  @EnquiryModule.Action public submitOptInConsent;

  @Prop({ default: 'Keep in Touch' })
  public label!: string;

  @Prop({
    default: () => []
  })
  public disallowedManufacturerIds!: number[];

  public optInAll: boolean = true;

  private optInData = new OptInData();

  public setOptIn(value: boolean) {
    this.optInData.OptInEmail = value;
    this.optInData.OptInSms = value;
    this.submitOptInConsent(this.optInData);
  }

  public get hasDisallowedManufacturers(): boolean {
    return this.disallowedManufacturerIds && this.disallowedManufacturerIds.length > 0;
  }

  public get currentManufacturerId(): number {
    return this.$store.getters['vehicleModule/currentManufacturerId'];
  }

  public get showComponent(): boolean {
    if (this.hasDisallowedManufacturers) {
      return !this.disallowedManufacturerIds.includes(this.currentManufacturerId);
    }

    return true;
  }

  @Watch('currentManufacturerId')
  public setDefaultConsent() {
    if (!this.showComponent) {
      this.setOptIn(false);
    }
  }

  public created() {
    this.optInData.OptInEmail = this.showComponent;
    this.optInData.OptInSms = this.showComponent;
    this.optInData.PolicyType = 1;
    this.optInData.PublishedPolicyId = this.initialSettings.marketingPolicyVersionId;
    this.submitOptInConsent(this.optInData);
  }
}
</script>
